import Icon from '../Icon';
import type { LucideIconData, LucideIconNode, LucideProps } from '../types';

export const __iconData: LucideIconData = {
  name: 'cookie',
  size: 24,
  node: [
    ['path', { d: 'M11 17h.01', key: 'dukryu' }],
    [
      'path',
      {
        d: 'M11.496 2c.324-.016.558.292.529.615a4 4 0 004.235 4.368.713.713 0 01.758.757 4 4 0 004.366 4.237c.323-.03.63.204.614.527a10 10 0 01-2.915 6.566A1 1 0 114.93 4.918 10 10 0 0111.496 2',
        key: '1x76et',
      },
    ],
    ['path', { d: 'M12 12h.01', key: '1mp3jc' }],
    ['path', { d: 'M16 16h.01', key: '1f9h7w' }],
    ['path', { d: 'M16 3h.01', key: 'll0zb8' }],
    ['path', { d: 'M21 4h.01', key: 'uw58yv' }],
    ['path', { d: 'M21 8h.01', key: '17axm7' }],
    ['path', { d: 'M7 14h.01', key: '1qa3f1' }],
    ['path', { d: 'M9 8h.01', key: '1jwowd' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Cookie
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgMTdoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xMS40OTYgMmMuMzI0LS4wMTYuNTU4LjI5Mi41MjkuNjE1YTQgNCAwIDAwNC4yMzUgNC4zNjguNzEzLjcxMyAwIDAxLjc1OC43NTcgNCA0IDAgMDA0LjM2NiA0LjIzN2MuMzIzLS4wMy42My4yMDQuNjE0LjUyN2ExMCAxMCAwIDAxLTIuOTE1IDYuNTY2QTEgMSAwIDExNC45MyA0LjkxOCAxMCAxMCAwIDAxMTEuNDk2IDIiIC8+CiAgPHBhdGggZD0iTTEyIDEyaC4wMSIgLz4KICA8cGF0aCBkPSJNMTYgMTZoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xNiAzaC4wMSIgLz4KICA8cGF0aCBkPSJNMjEgNGguMDEiIC8+CiAgPHBhdGggZD0iTTIxIDhoLjAxIiAvPgogIDxwYXRoIGQ9Ik03IDE0aC4wMSIgLz4KICA8cGF0aCBkPSJNOSA4aC4wMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/cookie
 * @see https://lucide.dev/guide/packages/lucide-solid - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Cookie = (props: LucideProps) => <Icon {...props} icon={__iconData} />;

export default Cookie;
